// @ts-nocheck
// ====== Entry point Vite ======
// Ogni modulo importato esegue il suo codice top-level (side-effect import)
// e registra le sue funzioni su `globalThis`. L'ordine conta: i moduli che
// usano API definite da altri devono venire dopo.
//
// Struttura cartelle:
//   lib/    -> fondamenta tecniche (utils, modal, client, ecc.)
//   data/   -> data layer dominio Ma.Se. + integrazioni Supabase
//   ui/     -> render layer (viste + componenti UI complessi)

// 1. Base (no deps)
import './lib/constants.js';
import './lib/utils.js';
import './lib/safe-html.js';
import './lib/highlight.js';
import './lib/event-bus.js'; // S3
import './lib/views-loader.js'; // S1
import './lib/error-tracking.js';
import './lib/supabase-client.js';

// 2. Data layer + auth
import './data/state.js';
import './data/state-api.js';
import './lib/modals.js';
import './lib/modal-a11y.js';
import './lib/dirty-guard.js';
import './data/audit.js';
import './data/auth.js';

// 3. Notifications + webhook + realtime data (usano sb, auth)
import './data/user-prefs.js';
import './data/notifications.js';
import './data/webhook.js';
import './data/realtime.js';

// 4. Servizi cross-modulo
import './lib/cache.js';
import './ui/charts.js';
import './ui/area-collectors.js'; // W2: collector puri cruscotto (F1-F5)
import './data/area-trends.js'; // W2: trend storico da snapshot backup (F6)
import './data/storage.js';
import './ui/pdf-export.js';
import './ui/xlsx-export.js';
import './ui/xlsx-presets.js'; // F6: preset extra (Audit, Pivot, Calendario)
import './ui/snooze.js';
import './data/audit-server.js'; // F7: filtri server-side audit
import './data/commenti.js'; // F2: commenti clienti

// 5. Render layer
import './ui/dashboard.js';
import './ui/heatmap.js'; // G3 (deve essere disponibile prima di dashboard.renderHeatmap)
import './ui/health.js';
import './ui/clienti-sublists.js';
import './ui/clienti-filters.js'; // S4: filtro/ricerca estratti da clienti.js
import './ui/clienti.js';
import './ui/clienti-wizard.js'; // percorso guidato nuovo cliente (estratto da clienti.js)
import './ui/clienti-events.js'; // S2 partial
import './ui/mei-clienti-filter.js'; // F3
import './ui/bulk-edit.js';
import './ui/import-clienti.js';
import './ui/import-extra.js';
import './ui/risorse.js';
import './ui/risorsa-detail.js';
import './ui/ruoli.js';
import './ui/pm.js';
import './ui/azioni.js';
import './ui/kanban.js'; // F1
import './ui/scadenze.js';
import './ui/scadenze-calendar.js';
import './ui/calendario-unico.js'; // F4
import './ui/controllo-area.js'; // W2: cruscotto direzionale Controllo area (G1)
import './ui/sicurezza.js';
import './ui/sicurezza-events.js'; // S2 partial
import './ui/trash.js';
import './data/backups.js';
import './lib/crypto-export.js'; // F11
import './ui/backup-encrypt-ui.js'; // F11
import './data/todos.js';
import './ui/todos.js';
import './ui/todos-events.js'; // S2 partial
import './ui/profilo.js';
import './ui/commenti.js'; // F2
import './ui/preview-card.js'; // F10

// 6. Router + UI prefs (usano i render layer)
import './ui/router.js';
import './ui/ui-prefs.js';
import './ui/ui-polish.js';
import './ui/onboarding.js';
import './ui/quick-switcher.js';
import './ui/quick-switcher-actions.js'; // F8
import './ui/global-search.js'; // ricerca globale dalla barra in alto (risultati da ogni vista)
import './ui/saved-views.js';
import './data/version-watch.js';

// ====== Bootstrap dell'app ======
(async () => {
  const profile = await fetchCurrentUserProfile();
  if (profile) {
    state.currentUser = profile.name;
    try {
      if (typeof setSyncState === 'function') setSyncState('refreshing');
      await loadStateFromSupabase();
      if (typeof setSyncState === 'function') setSyncState('ok');
    } catch (e) {
      console.error('Errore caricamento dati', e);
      toast('Errore caricamento dati dal server');
      if (typeof setSyncState === 'function') setSyncState('error');
    }
    showApp();
    renderAll();
    setView('dashboard');
    // S1: preload opportunistico delle view più probabili
    if (typeof preloadLikelyViews === 'function') preloadLikelyViews();
    if (typeof loadRuoliPredefiniti === 'function') loadRuoliPredefiniti();
    if (typeof ensureRecentAutoBackup === 'function') ensureRecentAutoBackup();
    if (typeof loadUserPrefs === 'function') {
      try {
        await loadUserPrefs();
      } catch (_) {
        /* soft fail */
      }
    }
    if (typeof bootstrapNotificationsForLogin === 'function') bootstrapNotificationsForLogin();
    if (typeof maybeStartOnboarding === 'function') maybeStartOnboarding();
    if (typeof startDataRealtime === 'function') startDataRealtime();
    if (typeof startVersionWatch === 'function') startVersionWatch();
  } else {
    showLogin();
  }
  if (typeof hideBootSplash === 'function') hideBootSplash();
})();
